
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profil-firmowy/[slug]",
      function () {
        return require("private-next-pages/profil-firmowy/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profil-firmowy/[slug]"])
      });
    }
  